export const styles = {
  label: {
    color: '#000',
    fontSize: 14,
    flex: 1,
  },
};
